(function () {
  var initialized = false;

  function injectCSS() {
    var style = document.createElement('style');
    style.textContent =
      '.insta-carousel-outer{position:relative;overflow:hidden;}' +
      '.insta-carousel-track{scrollbar-width:none;-ms-overflow-style:none;}' +
      '.insta-carousel-track::-webkit-scrollbar{display:none;}' +
      '.insta-carousel-btn{' +
        'position:absolute;top:50%;transform:translateY(-50%);z-index:10;' +
        'background:rgba(255,255,255,0.92);border:none;width:38px;height:38px;' +
        'border-radius:50%;font-size:1.7rem;line-height:1;cursor:pointer;' +
        'display:flex;align-items:center;justify-content:center;' +
        'box-shadow:0 2px 10px rgba(0,0,0,0.2);color:#1a1a1a;padding:0;' +
        'transition:opacity 0.2s;' +
      '}' +
      '.insta-carousel-btn:hover:not(:disabled){background:#fff;}' +
      '.insta-carousel-btn:disabled{opacity:0.2;cursor:default;}' +
      '.insta-carousel-btn--prev{left:10px;}' +
      '.insta-carousel-btn--next{right:10px;}' +
      /* Square on desktop, taller (portrait) on mobile */
      '.insta-carousel-card{aspect-ratio:1/1!important;}' +
      '@media(max-width:767px){.insta-carousel-card{aspect-ratio:3/5!important;}}';
    document.head.appendChild(style);
  }

  function applyCarousel(container) {
    if (container.dataset.carouselDone) return;
    container.dataset.carouselDone = '1';

    // Hide the Foursixty "Load more" button — not useful in carousel
    var nextPage = container.querySelector('[id*="fs-next-page"], .fs-next-page, [class*="fs-next"]');
    if (nextPage) nextPage.style.setProperty('display', 'none', 'important');

    // Hide the branding separator
    var branding = container.querySelector('.branding-separator, [class*="branding"]');
    if (branding) branding.style.setProperty('display', 'none', 'important');

    // Wrap in outer div for button positioning + overflow clip
    var outer = document.createElement('div');
    outer.className = 'insta-carousel-outer';
    container.parentNode.insertBefore(outer, container);
    outer.appendChild(container);

    // Convert .fs-timeline to a horizontal scroll track
    container.classList.add('insta-carousel-track');
    [
      ['display',          'flex'],
      ['flex-direction',   'row'],
      ['flex-wrap',        'nowrap'],
      ['overflow-x',       'auto'],
      ['overflow-y',       'visible'],
      ['scroll-snap-type', 'x mandatory'],
      ['gap',              '4px'],
      ['padding',          '0 10px'],
      ['align-items',      'flex-start'],
    ].forEach(function (p) { container.style.setProperty(p[0], p[1], 'important'); });

    // Style each .fs-entry-container as a fixed-width square card
    var cards = Array.from(container.children).filter(function (c) {
      return c.classList.contains('fs-entry-container');
    });
    cards.forEach(function (card) {
      card.classList.add('insta-carousel-card');
      [
        ['flex',             '0 0 min(340px, 72vw)'],
        ['width',            'min(340px, 72vw)'],
        ['min-width',        'min(340px, 72vw)'],
        ['max-width',        'min(340px, 72vw)'],
        ['scroll-snap-align','start'],
        ['overflow',         'hidden'],
      ].forEach(function (p) { card.style.setProperty(p[0], p[1], 'important'); });

      // Make the photo tile fill its card
      var entry = card.querySelector('.fs-timeline-entry, [id*="fs-post"]');
      if (entry) {
        entry.style.setProperty('width',  '100%', 'important');
        entry.style.setProperty('height', '100%', 'important');
        entry.style.setProperty('background-size',     'cover',  'important');
        entry.style.setProperty('background-position', 'center', 'important');
      }
    });

    // Prev / next navigation buttons
    function makeBtn(label, glyph, cls) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'insta-carousel-btn ' + cls;
      btn.setAttribute('aria-label', label);
      btn.textContent = glyph;
      return btn;
    }
    var prevBtn = makeBtn('Précédent', '‹', 'insta-carousel-btn--prev');
    var nextBtn = makeBtn('Suivant',   '›', 'insta-carousel-btn--next');
    outer.appendChild(prevBtn);
    outer.appendChild(nextBtn);

    prevBtn.addEventListener('click', function () {
      var cardW = (cards[0] ? cards[0].offsetWidth : 280) + 4;
      container.scrollBy({ left: -cardW, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      var cardW = (cards[0] ? cards[0].offsetWidth : 280) + 4;
      container.scrollBy({ left: cardW, behavior: 'smooth' });
    });

    function updateBtns() {
      prevBtn.disabled = container.scrollLeft <= 2;
      nextBtn.disabled = container.scrollLeft >= container.scrollWidth - container.clientWidth - 2;
    }
    container.addEventListener('scroll', updateBtns, { passive: true });
    updateBtns();
  }

  function initCarousel() {
    if (initialized) return;

    // Foursixty minifeed renders .fs-timeline as the grid container
    var container = document.querySelector('.fs-timeline') ||
                    document.querySelector('[id*="fs-timeline"]');
    if (!container) return;

    // Wait until .fs-entry-container cards are in the DOM
    var cards = container.querySelectorAll('.fs-entry-container');
    if (cards.length < 4) return;

    applyCarousel(container);
    initialized = true;
  }

  injectCSS();

  var attempts = 0;
  var timer = setInterval(function () {
    initCarousel();
    if (initialized || ++attempts > 60) clearInterval(timer);
  }, 300);
})();
